export enum AttOwnerType {
  Unknown = -1,
  Borrower,
  Lender,
  Vendor,
}
